import React from 'react'
import checkmark from 'src/static/icons/png/ll_checkmark.png'
import cross from 'src/static/icons/png/ll_filter_selected.png'
import checkmarkWhite from 'src/static/icons/png/dark-mode/ll_checkmark_white.png'
import crossWhite from 'src/static/icons/png/dark-mode/ll_filter_selected_white.png'
import {
  CheckboxContainer,
  HiddenCheckbox,
  HiddenIcon,
  StyledCheckbox,
  StyledCheckmark,
  StyledCross,
} from './styles'

export const CustomCheckbox = ({
  className,
  checked,
  valid,
  isSmall,
  isCheckmark = true,
  isDarkMode = false,
  ...props
}) => {
  const checkMarkIcon = (
    <>
      {checked ? (
        <StyledCheckmark src={checkmark} alt={'checked'} isSmall={isSmall} />
      ) : (
        <HiddenIcon src={checkmark} alt={'checked'} isSmall={isSmall} />
      )}
    </>
  )

  const checkMarkIconWhite = (
    <>
      {checked ? (
        <StyledCheckmark src={checkmarkWhite} alt={'checked'} isSmall={isSmall} />
      ) : (
        <HiddenIcon src={checkmarkWhite} alt={'checked'} isSmall={isSmall} />
      )}
    </>
  )

  const crossIcon = (
    <>
      {checked ? (
        <StyledCross src={cross} alt={'checked'} isSmall={isSmall} />
      ) : (
        <HiddenIcon src={cross} alt={'checked'} isSmall={isSmall} />
      )}
    </>
  )

  const crossIconWhite = (
    <>
      {checked ? (
        <StyledCross src={crossWhite} alt={'checked'} isSmall={isSmall} />
      ) : (
        <HiddenIcon src={crossWhite} alt={'checked'} isSmall={isSmall} />
      )}
    </>
  )

  const renderIcon = () => {
    if (isCheckmark) {
      if (isDarkMode) {
        return checkMarkIconWhite
      } else {
        return checkMarkIcon
      }
    } else if (!isCheckmark && isDarkMode) {
      return crossIconWhite
    } else {
      return crossIcon
    }
  }

  return (
    <CheckboxContainer {...props} isSmall={isSmall}>
      <HiddenCheckbox checked={checked} {...props} type={'checkbox'} />
      <StyledCheckbox checked={checked} valid={valid} isSmall={isSmall}>
        {renderIcon()}
      </StyledCheckbox>
    </CheckboxContainer>
  )
}
